<template>
    <div class="bodymsg-box">
        <div class="flex flex-y-center mb-56">
            <div class="progress-tit">档案完成度{{ specialData.rate }}%</div>
            <van-progress class="progress" stroke-width="10px" color="#2FD0D5" :show-pivot="false" :percentage="specialData.rate" />
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${specialData.fond ? 'already' : ''}`"></div>
            <div class="msg-tit">护理中喜欢：</div>
            <div class="flex flex-y-center">
                <div :class="`change-btn ${specialData.fond == 1 ? 'active' : ''}`" @click="changeFond(1)">
                    聊天
                </div>
                <div :class="`change-btn ${specialData.fond == 2 ? 'active' : ''}`" @click="changeFond(2)">
                    睡觉
                </div>
            </div>
        </div>
        <div class="line flex flex-y-center mb-56">
            <div :class="`circle ${specialData.preferential ? 'already' : ''}`"></div>
            <div class="msg-tit">护理偏好：</div>
            <div class="flex flex-y-center">
                <div :class="`change-btn ${specialData.preferential == 1 ? 'active' : ''}`" @click="changePreferential(1)">
                    仪器
                </div>
                <div :class="`change-btn ${specialData.preferential == 2 ? 'active' : ''}`" @click="changePreferential(2)">
                    手工
                </div>
            </div>
        </div>
        <div class="lines flex flex-y-center">
            <div :class="`circle ${specialData.roomRateArray ? 'already' : ''}`"></div>
            <div class="msg-tit">房间偏好：</div>
        </div>
        <div class="options-box">
            <van-checkbox-group v-model="specialData.roomRateArray" @change="onRoomChanges" direction="horizontal">
                <div v-for="(item, index) in roomOptions" :key="index">
                    <van-checkbox class="like" :name="item.dictValue" checked-color="#2fd0d5" shape="square">
                        {{ item.dictLabel }}
                    </van-checkbox>
                </div>
            </van-checkbox-group>
        </div>
        <div class="lines flex flex-y-center">
            <div :class="`circle ${specialData.teaWaterArray ? 'already' : ''}`"></div>
            <div class="msg-tit">茶水偏好：</div>
        </div>
        <div class="options-box">
            <van-checkbox-group v-model="specialData.teaWaterArray" @change="onTeaChanges" direction="horizontal">
                <van-checkbox v-for="(item, index) in teaOptions" :key="index" class="like" :name="item.dictValue" checked-color="#2fd0d5" shape="square">
                    {{ item.dictLabel }}
                </van-checkbox>
            </van-checkbox-group>
        </div>
        <div class="lines flex flex-y-center">
            <div :class="`circle ${specialData.taboo ? 'already' : ''}`"></div>
            <div class="msg-tit">禁忌话题：</div>
        </div>
        <textarea @input="textChange()" class="descContent font30" v-model="specialData.taboo" placeholder="请输入内容" placeholder-class="descPlaceholder" adjust-position="false" cursor-spacing="100"></textarea>
        <div class="flex flex-x-center">
            <button class="save-btn" @click="saveSpecial">保存</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            specialData: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            teaOptions: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            roomOptions: {
                type: Array,
                default: function () {
                    return [];
                },
            },
        },
        data() {
            return {};
        },
        mounted() {

        },
        methods: {
            changeFond(num) {
                const fond = num;
                this.specialData.fond = fond;
            },
            changePreferential(num) {
                const preferential = num;
                this.specialData.preferential = preferential;
            },
            onRoomChanges(e) {
                this.specialData.roomRateArray = e
            },
            onTeaChanges(e) {
                this.specialData.teaWaterArray = e
            },
            textChange() { },
            // 保存
            saveSpecial() {
                this.$emit('onSpecialSave', this.specialData)
            },
        },
    };
</script>

<style lang="less" scoped>
    .mb-56 {
        margin-bottom: 56px;
    }

    .mt-50 {
        margin-top: 50px !important;
    }

    .bodymsg-box {
        width: 100%;
        padding: 30px 30px;
    }

    .progress-tit {
        min-width: 158px;
        font-size: 24px;
        color: #2fd0d5;
        margin-right: 20px;
    }

    .progress {
        flex: 1;
    }

    .line {
        margin-bottom: 70px;
    }

    .lines {
        margin-bottom: 40px;
    }

    .line-inner {
        padding: 0 35px;
        margin-bottom: 14px;
    }

    .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 22px;
        background: #d8d8d8;
    }

    .circle.already {
        background: #333f48;
    }

    .msg-tit {
        width: 188px;
        font-size: 28px;
        color: #35434c;
        margin-right: 48px;
    }

    .options-box {
        padding: 0 0 0 170px;
    }

    .input-short {
        width: 448px;
        border-bottom: 1px solid #999999;
        margin-left: 50px;
        margin-bottom: 40px;
        color: #35434c;
    }

    .input-long {
        width: 521px;
        border-bottom: 1px solid #999999;
        color: #35434c;
        margin-bottom: 70px;
    }

    .save-btn {
        width: 520px !important;
        height: 90px;
        background: #333f48;
        border-radius: 45px;
        color: #ffffff;
        font-size: 30px;
        line-height: 90px;
        padding: 0;
        margin-top: 50px;
        overflow: hidden;
        margin-bottom: 55px;
    }

    .change-btn {
        width: 150px;
        height: 60px;
        background: #f2f3f7;
        border-radius: 30px;
        margin-right: 30px;
        text-align: center;
        color: #a0acb5;
        font-size: 28px;
        line-height: 60px;
    }

    .change-btn.active {
        background: #2fd0d5;
        color: #fff;
    }

    .descContent {
        width: 690px;
        height: 310px;
        background: #f6f6f6;
        border-radius: 16px;
        border: 1px solid #979797;
        padding: 30px;
        color: #a0acb5;
        box-sizing: border-box;
    }

    :deep(input:disabled, input[disabled]) {
        color: #333f48;
        opacity: 1;
        -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
        -webkit-opacity: 1;
        background-color: transparent;
    }

    :deep(textarea) {
        color: #333f48;
        -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
    }
</style>
